'use strict';
import { Translation } from './models/translation';
import * as Handlebars from 'handlebars';
import * as moment from 'moment';
import * as accounting from 'accounting';
import { UserIdentity } from './models/UserIdentity';
export let language;
export let app = 'ITM-EXPENSE';

export let oneTimeToken = '';

export let queriesData: any[];
export let bwebConfig: any;
export let modulesData: {
  id: number;
  name: string;
  objType: string;
  systemId: number;
  app: string;
}[];
export let translationsData: Translation[];
export let companyConfiguration: any;
export let currencies: any;
export let taxes: any[];
export let SessionValues: any[];
export let applicationError = false;
export let displayOpenedObjectHistory = false;
export let displayLandingPageLink = false;
export let externalPortalProfileModuleId = 10062;
export let displayCartProductsAsCardsByDefault = false;
export let currentAppId = 0;
export let currentAppPrefix = '';
export let userIdentity: UserIdentity;
export let showSignaturePadTermsAndCondition = false;
export let signaturePadTermsAndConditionLink = '';
export let signaturePadTermsAndConditionText = '';
export let notNotified = true;
export let countCalled = false;
export let ssccHidden = false;
export let hideDetailsButtonInCardsSection = false;
export let hideDeleteButtonInCardsSection = false;

export let magb1Url: string;

export function setCountCalled(value: boolean) {
  countCalled = value == null ? false : value;
}

export function setNotNotified(value: boolean) {
  notNotified = value == null ? false : value;
}

export function setShowSignaturePadTermsAndCondition(value: boolean) {
  showSignaturePadTermsAndCondition = value == null ? false : value;
}

export function setSignaturePadTermsAndConditionLink(value: string) {
  signaturePadTermsAndConditionLink = value == null ? '' : value;
}

export function setSignaturePadTermsAndConditionText(value: string) {
  signaturePadTermsAndConditionText = value == null ? '' : value;
}

export function setDisplayOpenedObjectHistory(value: boolean) {
  displayOpenedObjectHistory = value == null ? false : value;
}

export function setDisplayLandingPageLink(value: boolean) {
  displayLandingPageLink = value == null ? false : value;
}

export function setSSCCHidden(value: boolean) {
  ssccHidden = value == null ? false : value;
}

export function setHideDetailsButtonInCardsSection(value: boolean) {
  hideDetailsButtonInCardsSection = value == null ? false : value;
}

export function setHideDeleteButtonInCardsSection(value: boolean) {
  hideDeleteButtonInCardsSection = value == null ? false : value;
}

export let forceDisplayModeAsTable = false;
export function setForceDisplayModeAsTable(value: boolean) {
  forceDisplayModeAsTable = value == null ? false : value;
}

export let goToSourceList = false;
export function setGoToSourceList(value: boolean) {
  goToSourceList = value == null ? false : value;
}

export let useNZSelectInLines = false;
export function setUseNZSelectInLines(value: boolean) {
  useNZSelectInLines = value == null ? false : value;
}

export let overrideQuantityDecimals = -1;
export function setOverrideQuantityDecimals(value: number) {
  overrideQuantityDecimals = value == null ? overrideQuantityDecimals : value;
}

export function setExternalPortalProfileModuleId(value: number) {
  externalPortalProfileModuleId =
    value == null ? externalPortalProfileModuleId : value;
}

export function setDisplayCartProductsAsCardsByDefault(value: boolean) {
  displayCartProductsAsCardsByDefault =
    value == null ? displayCartProductsAsCardsByDefault : value;
}

export function setUserIdentity(val: any) {
  userIdentity = val;
}

export function getTitleSuffix() {
  if (userIdentity == null) {
    return 'Portal';
  } else {
    return userIdentity.CompanyName;
  }
}

export function setCurrentAppId(val: number) {
  currentAppId = val;
}

export function appUrlPrefix(val: string) {
  currentAppPrefix = val;
}

export function setApplicationError(val: boolean) {
  applicationError = val;
}

export let applicationErrorDetails = {};
export function setApplicationErrorDetails(val: any) {
  applicationErrorDetails = val;
}
// export function modifyAppKey(key) {
//   app = key;
// }
export let applicationInitiated = false;
export function setApplicationInitiated(val: any) {
  applicationInitiated = val;
}

Handlebars.registerHelper('ifEquals', (arg1, arg2, options) => {
  return arg1 === arg2 ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('ifNotEquals', (arg1, arg2, options) => {
  return arg1 !== arg2 ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('ifGt', (arg1, arg2, options) => {
  return arg1 > arg2 ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifSt', (arg1, arg2, options) => {
  return arg1 < arg2 ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('sum', (arg1, arg2) => {
  return arg1 + arg2;
});
Handlebars.registerHelper('minus', (arg1, arg2) => {
  return arg1 - arg2;
});
Handlebars.registerHelper('translate', (value) => {
  const translateRow = translationsData.find(
    (t) => t.OrigianlText.toLowerCase() === value.toString().toLowerCase()
  );

  if (translateRow !== undefined && translateRow != null) {
    if (translateRow.Id === 0) {
      if (translateRow.TranslatedText === '') {
        return value;
      } else {
        return translateRow.TranslatedText;
      }
    } else {
      return translateRow.TranslatedText;
    }
  } else {
    return value;
  }
});

Handlebars.registerHelper('percentage', (arg1, arg2) => {
  return Math.round((arg1 / arg2) * 100);
});

Handlebars.registerHelper('dateFormat', (year, month, day, format) => {
  if (year === 0 || year === '') {
    return '';
  } else {
    const date = new Date(year, month, day);
    return moment(date).format(format);
  }
});

Handlebars.registerHelper('g', (args1) => {
  if (args1 === 'baseUrl') {
    return baseUrl;
  } else if (args1 === 'urlSuffix') {
    return getUrlSuffix();
  }
  // return import('globals')[args1];
});

Handlebars.registerHelper('image', (args1) => {
  if (args1 === '' || args1 == null) {
    return 'assets/not-available.jpg';
  }
  if (args1.startsWith('http')) {
    return args1;
  } else {
    const filename = args1.substring(args1.lastIndexOf('/') + 1);
    const encodedFileName = encodeURIComponent(filename);

    args1 = args1.replace(filename, encodedFileName);
    return `${apiBaseUrl}media/PreviewFile?path=${args1}&${getUrlSuffix()}`;
  }
});

Handlebars.registerHelper('amountcurr', (num, curr) => {
  const value = Number(num);
  const valueStr = accounting.formatNumber(
    value,
    companyConfiguration.AmountDecimal,
    companyConfiguration.ThousandSep,
    companyConfiguration.DecimalSep
  );

  if (curr === '' || curr === undefined) {
    return valueStr;
  } else {
    if (companyConfiguration.CurrencyOnRight) {
      return valueStr + ' ' + curr;
    } else {
      return curr + ' ' + valueStr;
    }
  }
});

Handlebars.registerHelper('amountcurrsubtract', (num1, num2, curr) => {
  const value = Number(num1 - num2);
  const valueStr = accounting.formatNumber(
    value,
    companyConfiguration.AmountDecimal,
    companyConfiguration.ThousandSep,
    companyConfiguration.DecimalSep
  );

  if (curr === '' || curr === undefined) {
    return valueStr;
  } else {
    if (companyConfiguration.CurrencyOnRight) {
      return valueStr + ' ' + curr;
    } else {
      return curr + ' ' + valueStr;
    }
  }
});

Handlebars.registerHelper('percentVal', (num) => {
  const value = Number(num);
  const valueStr = accounting.formatNumber(
    value,
    companyConfiguration.PercentDecimal,
    companyConfiguration.ThousandSep,
    companyConfiguration.DecimalSep
  );
  return valueStr + ' %';
});

Handlebars.registerHelper('amount', (num) => {
  const value = Number(num);
  return accounting.formatNumber(
    value,
    companyConfiguration.AmountDecimal,
    companyConfiguration.ThousandSep,
    companyConfiguration.DecimalSep
  );
});

Handlebars.registerHelper('propHtml', function (arg1) {
  if (
    SessionValues != null &&
    SessionValues !== undefined &&
    SessionValues[arg1] != null &&
    SessionValues[arg1] !== undefined &&
    SessionValues[arg1] !== ''
  ) {
    arg1 = SessionValues[arg1];
  }

  //console.log('arg1', arg1, this);
  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return new Handlebars.SafeString('');
  }

  const property = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  );

  let value = property.ValueAsObject;
  if (property.DataType !== 5) {
    return new Handlebars.SafeString(value ?? '');
  }

  const ckDate = new Date(parseInt(property.Value, 0));
  if (moment(property.ValueAsObject, moment.ISO_8601, true).isValid()) {
    if (companyConfiguration) {
      return new Handlebars.SafeString(
        moment(new Date(value)).format(companyConfiguration.MomentDateFormat)
      );
    } else {
      return new Handlebars.SafeString(
        moment(new Date(parseInt(value, 0))).format('yyyy-MM-DD')
      );
    }
  }

  if (
    value !== undefined &&
    value !== null &&
    value.toString().startsWith('/Date(')
  ) {
    value = value.replace('/Date(', '').replace(')/', '');
    if (companyConfiguration) {
      return new Handlebars.SafeString(
        moment(new Date(parseInt(value, 0))).format(
          companyConfiguration.MomentDateFormat
        )
      );
    } else {
      return new Handlebars.SafeString(
        moment(new Date(parseInt(value, 0))).format('yyyy-MM-DD')
      );
    }
  }

  return new Handlebars.SafeString(value);
});

Handlebars.registerHelper('prop', function (arg1) {
  if (
    SessionValues != null &&
    SessionValues !== undefined &&
    SessionValues[arg1] != null &&
    SessionValues[arg1] !== undefined &&
    SessionValues[arg1] !== ''
  ) {
    arg1 = SessionValues[arg1];
  }

  //console.log('arg1', arg1, this);
  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return '';
  }

  const property = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  );

  let value = property.ValueAsObject;
  if (property.DataType !== 5) {
    return value;
  }

  const ckDate = new Date(parseInt(property.Value, 0));
  if (moment(property.ValueAsObject, moment.ISO_8601, true).isValid()) {
    if (companyConfiguration) {
      return moment(new Date(value)).format(
        companyConfiguration.MomentDateFormat
      );
    } else {
      return moment(new Date(parseInt(value, 0))).format('yyyy-MM-DD');
    }
  }

  if (
    value !== undefined &&
    value !== null &&
    value.toString().startsWith('/Date(')
  ) {
    value = value.replace('/Date(', '').replace(')/', '');
    if (companyConfiguration) {
      return moment(new Date(parseInt(value, 0))).format(
        companyConfiguration.MomentDateFormat
      );
    } else {
      return moment(new Date(parseInt(value, 0))).format('yyyy-MM-DD');
    }
  }

  return value;
});

Handlebars.registerHelper('imageprop', function (arg1) {
  if (
    SessionValues != null &&
    SessionValues !== undefined &&
    SessionValues[arg1] != null &&
    SessionValues[arg1] !== undefined &&
    SessionValues[arg1] !== ''
  ) {
    arg1 = SessionValues[arg1];
  }

  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return 'assets/not-available.jpg';
  }

  const property = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  );

  let value = property.ValueAsObject;

  if (value === '' || value == null) {
    return 'assets/not-available.jpg';
  }
  if (value.startsWith('http')) {
    return value;
  } else {
    const filename = value.substring(value.lastIndexOf('/') + 1);
    const encodedFileName = encodeURIComponent(filename);

    value = value.replace(filename, encodedFileName);
    return `${apiBaseUrl}media/PreviewFile?preview=true&path=${value}&${getUrlSuffix()}`;
  }
});

Handlebars.registerHelper('complexObject', function (arg1: string) {
  if (this === undefined) {
    return '';
  }

  let value = this;
  if (arg1.includes('.')) {
    const keys = arg1.split(',');
    keys.forEach((key) => {
      value = this[key];
    });
  }
  return value;
});
Handlebars.registerHelper('propObject', function (arg1) {
  if (this === undefined || this[arg1] === undefined) {
    return '';
  }

  const value = this[arg1];
  return value;
});
Handlebars.registerHelper('divide', (arg1, arg2) => {
  return arg1 / arg2;
});
Handlebars.registerHelper('multiply', (arg1, arg2) => {
  return arg1 * arg2;
});

Handlebars.registerHelper('propRestrict', function (arg1, arg2) {
  if (
    SessionValues != null &&
    SessionValues !== undefined &&
    SessionValues[arg1] != null &&
    SessionValues[arg1] !== undefined &&
    SessionValues[arg1] !== ''
  ) {
    arg1 = SessionValues[arg1];
  }

  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return '';
  }

  const property = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  );

  if (property == null || property.ValueAsObject == null) {
    return '';
  } else {
    const value = property.ValueAsObject.toString();
    if (value.length > arg2) {
      return value.substring(0, arg2) + ' ...';
    }

    return value;
  }
});

Handlebars.registerHelper('dateProp', function (arg1) {
  if (
    SessionValues != null &&
    SessionValues !== undefined &&
    SessionValues[arg1] != null &&
    SessionValues[arg1] !== undefined &&
    SessionValues[arg1] !== ''
  ) {
    arg1 = SessionValues[arg1];
  }

  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return '';
  }

  const value = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  ).ValueAsObject;

  return moment(value).format(companyConfiguration.MomentDateFormat);
});

Handlebars.registerHelper('propSerialBatch', function (arg1) {
  if (
    this === undefined ||
    this.Properties === undefined ||
    this.Properties.find((p) => p.Name.toLowerCase() === arg1.toLowerCase()) ===
      undefined
  ) {
    return '';
  }

  const value = this.Properties.find(
    (p) => p.Name.toLowerCase() === arg1.toLowerCase()
  ).ValueAsObject;

  return value;
});

export function getUrlSuffix() {
  language = language == null || language === 'undefined' ? 'en' : language;
  return `token=${getToken()}&app=${app}&language=${language}`;
}

export function getToken() {
  if (oneTimeToken === '') {
    return localStorage.getItem('token');
  } else {
    return oneTimeToken;
  }
}

export function setOneTimeToken(value: string) {
  oneTimeToken = value;
}

export function getSessionId() {
  return localStorage.getSession('sessionId');
}
export let uiSettings: any = {};
export function setUiSettings(value: any) {
  uiSettings = value;
}

export let notifications: any = {};
export function setNotifications(value: any) {
  notifications = value;
}
export let showDownloadButton: any;
export function setShowDownloadButton(value: any) {
  showDownloadButton = value;
}
export let queryIds: { [key: string]: number } = {};

export function setQueryId(key: string, id: number) {
  queryIds[key] = id;
}

export function getQueryId(key: string): number | undefined {
  return queryIds[key];
}
export function setPrimaryColor(rgb: string) {
  if (rgb) {
    document.documentElement.style.setProperty('--bweb-primary-rgb', rgb);
  }
}
export let logoUrl: string = '';
export function setLogoUrl(url: string) {
  logoUrl = url;
}
export function getLogoUrl(): string | null {
  return logoUrl;
}
export let apiBaseUrl = '';
export function setApiBaseUrl(value: string) {
  apiBaseUrl = value;
  document['apiBaseUrl'] = value;
}

export let baseUrl = '';
export function setBaseUrl(value: string) {
  baseUrl = value;
  document['baseUrl'] = value;
}

export let emailsServiceUrl = '';
export function setEmailsServiceUrl(value: string) {
  emailsServiceUrl = `${value}api/`;
}
export let emailsServiceCreds: { username: string; password: string };
export function setEmailsServiceCreds(value: any) {
  emailsServiceCreds = value;
}
export function setLanguage(value: string) {
  language = value;
}

export let locale = '';
export function setLocale(value) {
  locale = value;
}

export let redirectToExternalLogin = false;
export function setRedirectToExternalLogin(value) {
  redirectToExternalLogin = value;
}

export let grossPriceChangeResetDiscount = false;
export function setgrossPriceChangeResetDiscount(value) {
  if (value == undefined) {
    grossPriceChangeResetDiscount = false;
  } else {
    grossPriceChangeResetDiscount = value;
  }
}

export let allowClearDate = false;
export function setAllowClearDate(value) {
  if (value == undefined) {
    allowClearDate = false;
  } else {
    allowClearDate = value;
  }
}

export let filterFormatDate = 'N';
export function setfilterFormatDate(value) {
  if (value == undefined) {
    filterFormatDate = 'N';
  } else {
    filterFormatDate = value;
  }
}

export let multiOptionsSeparator = ',';
export function setMultiOptionsSeparator(value) {
  if (value == undefined) {
    multiOptionsSeparator = ',';
  } else {
    multiOptionsSeparator = value;
  }
}

export let pageSizeInLineSection = 10;
export function setPageSizeInLineSection(value) {
  if (value == undefined) {
    pageSizeInLineSection = 10;
  } else {
    pageSizeInLineSection = value;
  }
}

export let enablePaginationInLineSection = false;
export function setEnablePaginationInLineSection(value) {
  if (value == undefined) {
    enablePaginationInLineSection = false;
  } else {
    enablePaginationInLineSection = value;
  }
}

export let hideLinesWithZeroQtyForDocs = '';
export function setHideLinesWithZeroQtyForDocs(value) {
  if (value == undefined) {
    hideLinesWithZeroQtyForDocs = '';
  } else {
    hideLinesWithZeroQtyForDocs = value;
  }
}

export let enableSearchOnPartForObject = '';
export function setEnableSearchOnPartForObject(value) {
  if (value == undefined) {
    enableSearchOnPartForObject = '';
  } else {
    enableSearchOnPartForObject = value;
  }
}

export let lengthForSearchOnPart = 0;
export function setLengthForSearchOnPart(value: number) {
  lengthForSearchOnPart = value == null ? lengthForSearchOnPart : value;
}

export let autoSubmitSaveDraftForModules = '';
export function setAutoSubmitSaveDraftForModules(value) {
  if (value == undefined) {
    autoSubmitSaveDraftForModules = '';
  } else {
    autoSubmitSaveDraftForModules = value;
  }
}

export let autoRefreshListForModules = '';
export function setAutoRefreshListForModules(value) {
  if (value == undefined) {
    autoRefreshListForModules = '';
  } else {
    autoRefreshListForModules = value;
  }
}

export let autoRefreshListIntervalInMinutes = 1;
export function setAutoRefreshListIntervalInMinutes(value) {
  if (value == undefined) {
    autoRefreshListIntervalInMinutes = 1;
  } else {
    autoRefreshListIntervalInMinutes = value;
  }
}

export let customDueDateLogic = false;
export function setCustomDueDateLogic(value) {
  if (value == undefined) {
    customDueDateLogic = false;
  } else {
    customDueDateLogic = value;
  }
}

export let itemDetailsFooterOnTop = false;
export function setItemDetailsFooterOnTop(value) {
  if (value == undefined) {
    itemDetailsFooterOnTop = false;
  } else {
    itemDetailsFooterOnTop = value;
  }
}

export let inCountingBatchDisplayDetailMessage = false;
export function setInCountingBatchDisplayDetailMessage(value) {
  if (value == undefined) {
    inCountingBatchDisplayDetailMessage = false;
  } else {
    inCountingBatchDisplayDetailMessage = value;
  }
}

export let loadDraftAfterCreate = false;
export function setLoadDraftAfterCreate(value) {
  if (value == undefined) {
    loadDraftAfterCreate = false;
  } else {
    loadDraftAfterCreate = value;
  }
}

export let sc_SaveAsDraftAlwaysCP = false;
export function setSC_SaveAsDraftAlwaysCP(value) {
  if (value == undefined) {
    sc_SaveAsDraftAlwaysCP = false;
  } else {
    sc_SaveAsDraftAlwaysCP = value;
  }
}

export let sc_SaveAsDraftAlwaysEP = false;
export function setSC_SaveAsDraftAlwaysEP(value) {
  if (value == undefined) {
    sc_SaveAsDraftAlwaysEP = false;
  } else {
    sc_SaveAsDraftAlwaysEP = value;
  }
}

export let inCountingNormalItemisplayDetailMessage = false;
export function setInCountingNormalItemisplayDetailMessage(value) {
  if (value == undefined) {
    inCountingNormalItemisplayDetailMessage = false;
  } else {
    inCountingNormalItemisplayDetailMessage = value;
  }
}

export let inCountingNormalItemDisplayConfirmMessage = false;
export function setInCountingNormalItemDisplayConfirmMessage(value) {
  if (value == undefined) {
    inCountingNormalItemDisplayConfirmMessage = false;
  } else {
    inCountingNormalItemDisplayConfirmMessage = value;
  }
}

export let inCountingDeleteNormalItemAllowChooseQty = false;
export function setInCountingDeleteNormalItemAllowChooseQty(value) {
  if (value == undefined) {
    inCountingDeleteNormalItemAllowChooseQty = false;
  } else {
    inCountingDeleteNormalItemAllowChooseQty = value;
  }
}

export let inCountingDisableCumulativeModeForNormal = false;
export function setInCountingDisableCumulativeModeForNormal(value) {
  if (value == undefined) {
    inCountingDisableCumulativeModeForNormal = false;
  } else {
    inCountingDisableCumulativeModeForNormal = value;
  }
}

export let calcTotalAccordingToQty = true;
export function setCalcTotalAccordingToQty(value) {
  if (value == undefined) {
    calcTotalAccordingToQty = true;
  } else {
    calcTotalAccordingToQty = value;
  }
}

export let displayExpirationDateForBinBatchs = false;
export function setDisplayExpirationDateForBinBatchs(value) {
  if (value == undefined) {
    displayExpirationDateForBinBatchs = false;
  } else {
    displayExpirationDateForBinBatchs = value;
  }
}

export let validationBeforeCheckout = false;
export function setValidationBeforeCheckout(value) {
  if (value == undefined) {
    validationBeforeCheckout = false;
  } else {
    validationBeforeCheckout = value;
  }
}

export let enableItemImportation = false;
export function setEnableItemImportation(value) {
  if (value == undefined) {
    enableItemImportation = false;
  } else {
    enableItemImportation = value;
  }
}

export let backToPackagePage = false;
export function setBackToPackagePage(value) {
  if (value == undefined) {
    backToPackagePage = false;
  } else {
    backToPackagePage = value;
  }
}

export let disablePayingMultiDocument = false;
export function setDisablePayingMultiDocument(value) {
  if (value == undefined) {
    disablePayingMultiDocument = false;
  } else {
    disablePayingMultiDocument = value;
  }
}

export let specialTextIsHTML = false;
export function setSpecialTextIsHTML(value) {
  if (value == undefined) {
    specialTextIsHTML = false;
  } else {
    specialTextIsHTML = value;
  }
}

export let allowBulkLineDelete = false;
export function setAllowBulkLineDelete(value) {
  if (value == undefined) {
    allowBulkLineDelete = false;
  } else {
    allowBulkLineDelete = value;
  }
}

export let allowBulkLineCloseForModules = '';
export function setAllowBulkLineCloseForModules(value) {
  if (value == undefined) {
    allowBulkLineCloseForModules = '';
  } else {
    allowBulkLineCloseForModules = value;
  }
}

export let showSpinnerWhenAddingBOM = false;
export function setShowSpinnerWhenAddingBOM(value) {
  if (value == undefined) {
    showSpinnerWhenAddingBOM = false;
  } else {
    showSpinnerWhenAddingBOM = value;
  }
}

export let showSupplierSSCCNumberField = true;
export function setShowSupplierSSCCNumberField(value) {
  if (value == undefined) {
    showSupplierSSCCNumberField = true;
  } else {
    showSupplierSSCCNumberField = value;
  }
}

export let showMnfSerialField = true;
export function setShowMnfSerialField(value) {
  if (value == undefined) {
    showMnfSerialField = true;
  } else {
    showMnfSerialField = value;
  }
}

export let showAcceptanceOnlinePaymentMsg = false;
export function setShowAcceptanceOnlinePaymentMsg(value) {
  if (value == undefined) {
    showAcceptanceOnlinePaymentMsg = false;
  } else {
    showAcceptanceOnlinePaymentMsg = value;
  }
}

export let acceptanceOnlinePaymentMsg = '';
export function setAcceptanceOnlinePaymentMsg(value) {
  if (value == undefined) {
    acceptanceOnlinePaymentMsg = '';
  } else {
    acceptanceOnlinePaymentMsg = value;
  }
}

export let lookForBatchInBaseForReturn = false;
export function setLookForBatchInBaseForReturn(value) {
  if (value == undefined) {
    lookForBatchInBaseForReturn = false;
  } else {
    lookForBatchInBaseForReturn = value;
  }
}

export let allowBulkEdit = false;
export function setAllowBulkEdit(value) {
  if (value == undefined) {
    allowBulkEdit = false;
  } else {
    allowBulkEdit = value;
  }
}

export let enableAnnouncement = false;
export function setEnableAnnouncement(value) {
  if (value == undefined) {
    enableAnnouncement = false;
  } else {
    enableAnnouncement = value;
  }
}

export let ticketConversationIsOpen = false;
export function setTicketConversationIsOpen(value) {
  if (value == undefined) {
    ticketConversationIsOpen = false;
  } else {
    ticketConversationIsOpen = value;
  }
}

export let checkDatesBeforeAddLinesToOrder = false;
export function setCheckDatesBeforeAddLinesToOrder(value) {
  if (value == undefined) {
    checkDatesBeforeAddLinesToOrder = false;
  } else {
    checkDatesBeforeAddLinesToOrder = value;
  }
}

export let DontDisplayNotificationForNewItem = '';
export function setDontDisplayNotificationForNewItem(value) {
  if (value == undefined) {
    DontDisplayNotificationForNewItem = '';
  } else {
    DontDisplayNotificationForNewItem = value;
  }
}

export let defaultWarehouseInATP = '';
export function setDefaultWarehouseInATP(value) {
  if (value == undefined) {
    defaultWarehouseInATP = '';
  } else {
    defaultWarehouseInATP = value;
  }
}

export let uniqueBatchModeCounting = false;
export function setUniqueBatchModeCounting(value) {
  if (value == undefined) {
    uniqueBatchModeCounting = false;
  } else {
    uniqueBatchModeCounting = value;
  }
}

export let autoDisplayDeliverSchedule = false;
export function setAutoDisplayDeliverSchedule(value) {
  if (value == undefined) {
    autoDisplayDeliverSchedule = false;
  } else {
    autoDisplayDeliverSchedule = value;
  }
}

export let autoDisplayDeliverScheduleForQuantity = false;
export function setAutoDisplayDeliverScheduleForQuantity(value) {
  if (value == undefined) {
    autoDisplayDeliverScheduleForQuantity = false;
  } else {
    autoDisplayDeliverScheduleForQuantity = value;
  }
}

export let autoDisplayDeliverScheduleForShipDate = false;
export function setAutoDisplayDeliverScheduleForShipDate(value) {
  if (value == undefined) {
    autoDisplayDeliverScheduleForShipDate = false;
  } else {
    autoDisplayDeliverScheduleForShipDate = value;
  }
}

export let allowAddNewItemsInPackage = false;
export function setAllowAddNewItemsInPackage(value) {
  if (value == undefined) {
    allowAddNewItemsInPackage = false;
  } else {
    allowAddNewItemsInPackage = value;
  }
}

export let allowAddNewLinesInMiddle = false;
export function setAllowAddNewLinesInMiddle(value) {
  if (value == undefined) {
    allowAddNewLinesInMiddle = false;
  } else {
    allowAddNewLinesInMiddle = value;
  }
}

export let allowModifyUOMInSC = false;
export function setAllowModifyUOMInSC(value) {
  if (value == undefined) {
    allowModifyUOMInSC = false;
  } else {
    allowModifyUOMInSC = value;
  }
}

export let messageWhenChoosingBPQueryId = 0;
export function setMessageWhenChoosingBPQueryId(value) {
  if (value == undefined) {
    messageWhenChoosingBPQueryId = 0;
  } else {
    messageWhenChoosingBPQueryId = value;
  }
}

export let messageWhenEditingOrderQueryId = 0;
export function setMessageWhenEditingOrderQueryId(value) {
  if (value == undefined) {
    messageWhenEditingOrderQueryId = 0;
  } else {
    messageWhenEditingOrderQueryId = value;
  }
}

export let checkItemsInBaseDocumentQueryId = 0;
export function setCheckItemsInBaseDocumentQueryId(value) {
  if (value == undefined) {
    checkItemsInBaseDocumentQueryId = 0;
  } else {
    checkItemsInBaseDocumentQueryId = value;
  }
}

export let autoDisplayDeliverScheduleForOnHand = false;
export function setAutoDisplayDeliverScheduleForOnHand(value) {
  if (value == undefined) {
    autoDisplayDeliverScheduleForOnHand = false;
  } else {
    autoDisplayDeliverScheduleForOnHand = value;
  }
}

export let triggerDeliverScheduleForShipDate = false;
export function setTriggerDeliverScheduleForShipDate(value) {
  if (value == undefined) {
    triggerDeliverScheduleForShipDate = false;
  } else {
    triggerDeliverScheduleForShipDate = value;
  }
}

export let uniqueBatchModeGoodIssue = false;
export function setUniqueBatchModeGoodIssue(value) {
  if (value == undefined) {
    uniqueBatchModeGoodIssue = false;
  } else {
    uniqueBatchModeGoodIssue = value;
  }
}

export let setSumAppliedInCash = false;
export function setSetSumAppliedInCash(value) {
  if (value == undefined) {
    setSumAppliedInCash = false;
  } else {
    setSumAppliedInCash = value;
  }
}

export let enableReverseMode = false;
export function setEnableReverseMode(value) {
  if (value == undefined) {
    enableReverseMode = false;
  } else {
    enableReverseMode = value;
  }
}

export let enableAutoIncreaseMode = false;
export function setEnableAutoIncreaseMode(value) {
  if (value == undefined) {
    enableAutoIncreaseMode = false;
  } else {
    enableAutoIncreaseMode = value;
  }
}

export let enableMovingLineInUpdateMode = false;
export function setEnableMovingLineInUpdateMode(value) {
  if (value == undefined) {
    enableMovingLineInUpdateMode = false;
  } else {
    enableMovingLineInUpdateMode = value;
  }
}

export let showConfirmationForNormalItem = '';
export function setShowConfirmationForNormalItem(value) {
  if (value == undefined) {
    showConfirmationForNormalItem = '';
  } else {
    showConfirmationForNormalItem = value;
  }
}

export let checkBaseTotalForDocuments = '';
export function setCheckBaseTotalForDocuments(value) {
  if (value == undefined) {
    checkBaseTotalForDocuments = '';
  } else {
    checkBaseTotalForDocuments = value;
  }
}

export let checkItemsInBaseDocument = '';
export function setCheckItemsInBaseDocument(value) {
  if (value == undefined) {
    checkItemsInBaseDocument = '';
  } else {
    checkItemsInBaseDocument = value;
  }
}

export let checkItemsInBaseDocumentForActions = '';
export function setCheckItemsInBaseDocumentForActions(value) {
  if (value == undefined) {
    checkItemsInBaseDocumentForActions = '';
  } else {
    checkItemsInBaseDocumentForActions = value;
  }
}

export let showConfirmationForNewBatch = '';
export function setShowConfirmationForNewBatch(value) {
  if (value == undefined) {
    showConfirmationForNewBatch = '';
  } else {
    showConfirmationForNewBatch = value;
  }
}

export let childPropertiesShouldMatchParent = '';
export function setChildPropertiesShouldMatchParent(value) {
  if (value == undefined) {
    childPropertiesShouldMatchParent = '';
  } else {
    childPropertiesShouldMatchParent = value;
  }
}

export let checkPropertiesToIgnoreInCopyToForDocuments = '';
export function setCheckPropertiesToIgnoreInCopyToForDocuments(value) {
  if (value == undefined) {
    checkPropertiesToIgnoreInCopyToForDocuments = '';
  } else {
    checkPropertiesToIgnoreInCopyToForDocuments = value;
  }
}

export let propertiesToIgnoreInCopyTo = '';
export function setPropertiesToIgnoreInCopyTo(value) {
  if (value == undefined) {
    propertiesToIgnoreInCopyTo = '';
  } else {
    propertiesToIgnoreInCopyTo = value;
  }
}

export let checkPropertiesToTriggerInDuplicateForDocuments = '';
export function setCheckPropertiesToTriggerInDuplicateForDocuments(value) {
  if (value == undefined) {
    checkPropertiesToTriggerInDuplicateForDocuments = '';
  } else {
    checkPropertiesToTriggerInDuplicateForDocuments = value;
  }
}

export let copyFromAddressForDocuments = '';
export function setCopyFromAddressForDocuments(value) {
  if (value == undefined) {
    copyFromAddressForDocuments = '';
  } else {
    copyFromAddressForDocuments = value;
  }
}

export let checkPropertiesToTriggerInCopyToForDocuments = '';
export function setCheckPropertiesToTriggerInCopyToForDocuments(value) {
  if (value == undefined) {
    checkPropertiesToTriggerInCopyToForDocuments = '';
  } else {
    checkPropertiesToTriggerInCopyToForDocuments = value;
  }
}

export let enableItemFileImportationForDocuments = '';
export function setEnableItemFileImportationForDocuments(value) {
  if (value == undefined) {
    enableItemFileImportationForDocuments = '';
  } else {
    enableItemFileImportationForDocuments = value;
  }
}

export let enableBatchAllocationForDocuments = '';
export function setEnableBatchAllocationForDocuments(value) {
  if (value == undefined) {
    enableBatchAllocationForDocuments = '';
  } else {
    enableBatchAllocationForDocuments = value;
  }
}

export let disableAddingNewLinesForDocuments = '';
export function setDisableAddingNewLinesForDocuments(value) {
  if (value == undefined) {
    disableAddingNewLinesForDocuments = '';
  } else {
    disableAddingNewLinesForDocuments = value;
  }
}

export let sc_ExtraMessageForDraft = '';
export function setSC_ExtraMessageForDraft(value) {
  if (value == undefined) {
    sc_ExtraMessageForDraft = '';
  } else {
    sc_ExtraMessageForDraft = value;
  }
}

export let allowExceedOpenQtyForDocuments = '';
export function setAllowExceedOpenQtyForDocuments(value) {
  if (value == undefined) {
    allowExceedOpenQtyForDocuments = '';
  } else {
    allowExceedOpenQtyForDocuments = value;
  }
}

export let deleteIsOutOfActionsFor = '';
export function setDeleteIsOutOfActionsFor(value) {
  if (value == undefined) {
    deleteIsOutOfActionsFor = '';
  } else {
    deleteIsOutOfActionsFor = value;
  }
}

export let ignoreCheckApproveFor = '';
export function setIgnoreCheckApproveFor(value) {
  if (value == undefined) {
    ignoreCheckApproveFor = '';
  } else {
    ignoreCheckApproveFor = value;
  }
}

export let pNPCreationActionCode = '';
export function setPNPCreationActionCode(value) {
  if (value == undefined) {
    pNPCreationActionCode = 'CreatePickLists';
  } else {
    pNPCreationActionCode = value;
  }
}

export let pNPHideSplitStep = false;
export function setPNPHideSplitStep(value) {
  if (value == undefined) {
    pNPHideSplitStep = false;
  } else {
    pNPHideSplitStep = value;
  }
}

export let propertiesToTriggerInDuplicate = '';
export function setPropertiesToTriggerInDuplicate(value) {
  if (value == undefined) {
    propertiesToTriggerInDuplicate = '';
  } else {
    propertiesToTriggerInDuplicate = value;
  }
}

export let propertiesToTriggerInCopyTo = '';
export function setPropertiesToTriggerInCopyTo(value) {
  if (value == undefined) {
    propertiesToTriggerInCopyTo = '';
  } else {
    propertiesToTriggerInCopyTo = value;
  }
}

export let navigateToWebsites = false;
export function setNavigateToWebsites(value) {
  navigateToWebsites = value;
}

export let withCredentials = false;
export function setWithCredentials(value) {
  if (value == null) {
    withCredentials = false;
  }
}

export let enableDecisionControlsForAnyUser = false;
export function setEnableDecisionControlsForAnyUser(value) {
  if (value == null) {
    enableDecisionControlsForAnyUser = false;
  } else {
    enableDecisionControlsForAnyUser = value;
  }
}

export let updateQuantitiesForTemplateBOM = false;
export function setUpdateQuantitiesForTemplateBOM(value) {
  if (value == null) {
    updateQuantitiesForTemplateBOM = false;
  } else {
    updateQuantitiesForTemplateBOM = value;
  }
}

export let foreignIsRateMultplication = false;
export function setForeignIsRateMultplication(value) {
  if (value == null) {
    foreignIsRateMultplication = false;
  } else {
    foreignIsRateMultplication = value;
  }
}

export let updatePricesForSimilarItems = false;
export function setUpdatePricesForSimilarItems(value) {
  if (value == null) {
    updatePricesForSimilarItems = false;
  } else {
    updatePricesForSimilarItems = value;
  }
}

export let copyNumAtCardWhenCopyFrom = false;
export function setCopyNumAtCardWhenCopyFrom(value) {
  if (value == null) {
    copyNumAtCardWhenCopyFrom = false;
  } else {
    copyNumAtCardWhenCopyFrom = value;
  }
}

export let pnp_HideCreateDeliveryBTN = false;
export function setPNP_HideCreateDeliveryBTN(value) {
  if (value == null) {
    pnp_HideCreateDeliveryBTN = false;
  } else {
    pnp_HideCreateDeliveryBTN = value;
  }
}

export let pnp_HideCreateStockTransferBTN = false;
export function setPNP_HideCreateStockTransferBTN(value) {
  if (value == null) {
    pnp_HideCreateStockTransferBTN = false;
  } else {
    pnp_HideCreateStockTransferBTN = value;
  }
}

export let additionalFieldsCopyFromPOR = '';
export function setAdditionalFieldsCopyFromPOR(value) {
  if (value == undefined) {
    additionalFieldsCopyFromPOR = '';
  } else {
    additionalFieldsCopyFromPOR = value;
  }
}

export let additionalFieldsCopyFromPCH = '';
export function setAdditionalFieldsCopyFromPCH(value) {
  if (value == undefined) {
    additionalFieldsCopyFromPCH = '';
  } else {
    additionalFieldsCopyFromPCH = value;
  }
}

export let fieldsTobeCopiedWhenCopyFrom = '';
export function setFieldsTobeCopiedWhenCopyFrom(value) {
  if (value == null) {
    fieldsTobeCopiedWhenCopyFrom = '';
  } else {
    fieldsTobeCopiedWhenCopyFrom = value;
  }
}

export let oAT_FieldsTobeCopiedWhenCopyFromAddress = '';
export function setOAT_FieldsTobeCopiedWhenCopyFromAddress(value) {
  if (value == null) {
    oAT_FieldsTobeCopiedWhenCopyFromAddress = '';
  } else {
    oAT_FieldsTobeCopiedWhenCopyFromAddress = value;
  }
}

export let fieldsTobeCopiedWhenCopyFromAddress = '';
export function setFieldsTobeCopiedWhenCopyFromAddress(value) {
  if (value == null) {
    fieldsTobeCopiedWhenCopyFromAddress = '';
  } else {
    fieldsTobeCopiedWhenCopyFromAddress = value;
  }
}

export let allowEditEvenWhenClose = '';
export function setAllowEditEvenWhenClose(value) {
  if (value == null) {
    allowEditEvenWhenClose = '';
  } else {
    allowEditEvenWhenClose = value;
  }
}

export let uomQueryParamFields = '';
export function setUomQueryParamFields(value) {
  if (value == null) {
    uomQueryParamFields = '';
  } else {
    uomQueryParamFields = value;
  }
}

export let allowAddLinesEvenWhenClose = '';
export function setAllowAddLinesEvenWhenClose(value) {
  if (value == null) {
    allowAddLinesEvenWhenClose = '';
  } else {
    allowAddLinesEvenWhenClose = value;
  }
}

export let fieldsTobeCopiedWhenCopyFromForCredit = '';
export function setFieldsTobeCopiedWhenCopyFromForCredit(value) {
  if (value == null) {
    fieldsTobeCopiedWhenCopyFromForCredit = '';
  } else {
    fieldsTobeCopiedWhenCopyFromForCredit = value;
  }
}

export let hideITMFromFooter = false;
export function setHideITMFromFooter(value) {
  if (value == null) {
    hideITMFromFooter = false;
  } else {
    hideITMFromFooter = value;
  }
}

export let setDefaultDiscount = false;
export function setSetDefaultDiscount(value) {
  if (value == null) {
    setDefaultDiscount = false;
  } else {
    setDefaultDiscount = value;
  }
}

export let setDefaultDiscountOnQtyChange = false;
export function setSetDefaultDiscountOnQtyChange(value) {
  if (value == null) {
    setDefaultDiscountOnQtyChange = false;
  } else {
    setDefaultDiscountOnQtyChange = value;
  }
}

export let redirectToEmployeeLogin = false;
export function setRedirectToEmployeeLogin(value) {
  redirectToEmployeeLogin = value;
}

export function setQueriesData(value: []) {
  queriesData = value;
}

export function setBWEBConfig(value: any) {
  bwebConfig = value;
}

export function setModulesData(
  value: {
    id: number;
    name: string;
    objType: string;
    systemId: number;
    app: string;
  }[]
) {
  modulesData = value;
}

export function setTranslationsData(value: []) {
  translationsData = value;
}

export function setCompanyConfiguration(value: any) {
  companyConfiguration = value;
  if (overrideQuantityDecimals !== -1) {
    companyConfiguration.QuantityDecimal = overrideQuantityDecimals;
  }
}

export function setTaxes(value: any) {
  if (value.Data != null && value.Data !== undefined) taxes = value.Data;
  else taxes = value;
}

export function setCurrencies(value: any) {
  currencies = value;
}

export function setSessionValues(value: any) {
  SessionValues = value;
}

const origIsNaN = isNaN;
// @ts-ignore
isNaN = (str: any) => {
  if (
    str === undefined ||
    str == null ||
    str === '' ||
    companyConfiguration === undefined ||
    companyConfiguration === null
  ) {
    return origIsNaN(str);
  } else if (typeof str === 'string') {
    // @ts-ignore
    str = str.replaceAll(companyConfiguration.ThousandSep, '');
    str = str.replaceAll(companyConfiguration.DecimalSep, '.');

    return origIsNaN(str);
  } else {
    return origIsNaN(str);
  }
};

const origParseFloat = parseFloat;
// @ts-ignore
parseFloat = (str: any) => {
  const valueToReturn =
    typeof str === 'number' ? origParseFloat(str.toString()) : undefined;
  if (valueToReturn !== undefined) {
    return valueToReturn;
  }

  if (typeof str === 'number') {
    return origParseFloat(str.toString());
  } else if (
    str === undefined ||
    str == null ||
    str === '' ||
    companyConfiguration === undefined ||
    companyConfiguration === null
  ) {
    return origParseFloat(str);
  } else if (typeof str === 'string') {
    // @ts-ignore
    str = str.replaceAll(companyConfiguration.ThousandSep, '');
    str = str.replaceAll(companyConfiguration.DecimalSep, '.');

    return origParseFloat(str);
  } else {
    return origParseFloat(str);
  }
};

export function FormatDate(date: Date) {
  const format = companyConfiguration.MomentDateFormat;
  return moment(date).format(format);
}
export function getDocNameFromType(docType: number) {
  switch (docType) {
    case 13:
      return 'A/R Invoice';
    case 14:
      return 'A/R Credit Memo';
    case 15:
      return 'Delivery';
    case 16:
      return 'Return';
    case 17:
      return 'Sales Order';
    case 18:
      return 'A/P Invoice';
    case 19:
      return 'A/P Credit Memo';
    case 20:
      return 'Goods Receipt Po';
    case 22:
      return 'Purchase Order';
    case 23:
      return 'Sales Quotation';
    case 24:
      return 'Incoming Payment';
    case 203:
      return 'A/R Down Payment';
    case 204:
      return 'A/P Down Payment';
  }
}

export function normalizeKey(key: string): string {
  const map: Record<string, string> = {
    oOrder: 'oOrders',
  };

  return map[key] ?? key;
}

export function parseCustomConfiguration(input: string): Record<string, string[]> {
  const result: Record<string, string[]> = {};

  const blocks = input.match(/\[([^\]]+)\]/g) ?? [];

  for (const block of blocks) {
    const content = block.slice(1, -1);
    const [rawKey, values] = content.split(';');

    const key = this.normalizeKey(rawKey);

    result[key] = values ? values.split(',').map((v) => v.trim()) : [];
  }

  return result;
}
